var map = {
	"./tech-excel.svg": 2016,
	"./tech-git.svg": 2017,
	"./tech-google-sheets.svg": 2018,
	"./tech-gray-chatgpt.svg": 1120,
	"./tech-gray-excel.svg": 1121,
	"./tech-gray-git.svg": 1122,
	"./tech-gray-google-sheets.svg": 1123,
	"./tech-gray-jupyter.svg": 1124,
	"./tech-gray-multiple.svg": 1125,
	"./tech-gray-other.svg": 1126,
	"./tech-gray-powerbi.svg": 1127,
	"./tech-gray-python.svg": 1128,
	"./tech-gray-r.svg": 1129,
	"./tech-gray-sql.svg": 1130,
	"./tech-gray-tableau.svg": 1131,
	"./tech-gray-theory.svg": 1132,
	"./tech-powerbi.svg": 2019,
	"./tech-python (2).svg": 2020,
	"./tech-python.svg": 2021,
	"./tech-r.svg": 2022,
	"./tech-responsive-artificial-intelligence.svg": 528,
	"./tech-responsive-chatgpt.svg": 593,
	"./tech-responsive-data.svg": 594,
	"./tech-responsive-excel.svg": 595,
	"./tech-responsive-git.svg": 596,
	"./tech-responsive-google-sheets.svg": 597,
	"./tech-responsive-jupyter.svg": 598,
	"./tech-responsive-langchain.svg": 599,
	"./tech-responsive-multiple.svg": 600,
	"./tech-responsive-powerbi.svg": 601,
	"./tech-responsive-powerpoint.svg": 602,
	"./tech-responsive-python.svg": 603,
	"./tech-responsive-r.svg": 604,
	"./tech-responsive-sql.svg": 605,
	"./tech-responsive-tableau.svg": 606,
	"./tech-responsive-theory.svg": 607,
	"./tech-sql.svg": 2023,
	"./tech-tableau.svg": 2024,
	"./tech-theory.svg": 2025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3733;